import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap';
import Typography from '../components/Typography';
import axios from '../utils/posAxios';
import {
  MdCameraAlt,
  MdFace,
  MdDone,
  MdClear,
  MdWarning,
} from 'react-icons/md';
import Avatar from '../components/Avatar';
import userPlaceholder from '../assets/img/users/profile.jpg';
import StorageService from '../services/StorageService';
import NotificationSystem from 'react-notification-system';
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants';
import Compress from 'compress.js';
const compress = new Compress();

class PosStoreConfigureModal extends React.Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      company_name: '',
      store_id: '',
      image_url: '',
      web_footer: '',
      invoice_info: '',
      footer_info: '',
      quotation_tc: '',
      invoice_tc: '',
    };
  }

  changeHandler = e => {
    let { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  componentDidMount() {
    const store = this.props.data;
    this.setState({
      store_id: store.store_id,
      company_name: store.company_name,
      image_url: store.image_url,
      web_header: store.web_header,
      web_footer: store.web_footer,
      invoice_info: store.invoice_info,
      footer_info: store.footer_info,
      quotation_tc: store.quotation_tc,
      invoice_tc: store.invoice_tc,
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data.image_url !== state.image_url) {
      return {
        image_url: props.data.image_url,
        isLoading: false,
      };
    }
    return null;
  }

  handleAttachmentChange = async event => {
    let reader = new FileReader();
    if (Object.keys(event.target.files).length == 0) {
      // Object is empty
    } else {
      let file = event.target.files[0];
      if (file.size > 2000000) {
        this.notificationSystem.addNotification({
          title: <MdWarning />,
          message: 'Logo size limit to 2MB',
          level: 'error',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });
        event.target.value = null;
      } else {
        if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {
          this.notificationSystem.addNotification({
            title: <MdWarning />,
            message: 'Please select valid photo.',
            level: 'error',
            position: 'br',
            autoDismiss: 2,
            dismissible: 'click',
          });
        } else {
          reader.onloadend = () => {
            this.setState({
              isLoading: true,
            });
            let image = reader.result ? reader.result.split(',')[1] : '';
            this.AddImage(image);
          };
          reader.readAsDataURL(file);
        }
      }
    }
  };

  AddImage(b64image) {
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const user = StorageService.getSession('user_info');
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      b64image: b64image,
      created_by: user.email,
    };
    axios
      .post(url + ':3001/v1/store/image', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'New Image added successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        });

        this.props.getStoreDetail();
      })
      .catch(error => {
        alert(error);
      });
  }

  // resizeImageFn = async file => {
  //   const resizedImage = await compress.compress([file], {
  //     size: 2, // the max size in MB, defaults to 2MB
  //     quality: 1, // the quality of the image, max is 1,
  //     maxWidth: 800, // the max width of the output image, defaults to 1920px
  //     maxHeight: 800, // the max height of the output image, defaults to 1920px
  //     resize: true, // defaults to true, set false if you do not want to resize the image width and height
  //   });
  //   const img = resizedImage[0];
  //   const base64str = img.data;
  //   return base64str;
  //   // const imgExt = img.ext;
  //   // const resizedFiile = Compress.convertBase64ToFile(base64str, imgExt);
  //   // return resizedFiile;
  // };

  handleSubmit = e => {
    e.preventDefault();
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.store_id,
      company_name: this.state.company_name,
      web_header: this.state.web_header,
      web_footer: this.state.web_footer,
      invoice_info: this.state.invoice_info,
      footer_info: this.state.footer_info,
      quotation_tc: this.state.quotation_tc,
      invoice_tc: this.state.invoice_tc,
      update_by: user.email,
    };
    axios
      .post(url + ':3001/v2/store/update/config', data)
      .then(response => {
        const result = response.data;
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false);
          return;
        }

        this.props.closeModal(
          <MdDone />,
          'Config updated successfully.',
          'success',
          false,
        );
      })
      .catch(error => {
        alert(error);
      });
  };

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>
          Configuration
        </ModalHeader>
        <NotificationSystem
          dismissible={false}
          ref={notificationSystem =>
            (this.notificationSystem = notificationSystem)
          }
          style={NOTIFICATION_SYSTEM_STYLE}
        />
        <ModalBody style={{ maxHeight: 500, overflowY: 'auto' }}>
          {this.state.isLoading && (
            <div
              style={{
                position: 'fixed',
                left: '50%',
                top: '50%',
                marginLeft: '-10px',
              }}
            >
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          {/* <FormGroup>
            <div>
              <Input
                type="file"
                name="file"
                id="file"
                className="ps-input-file"
                onChange={this.handleAttachmentChange}
              />
              <Label for="file">
               
                Store Logo
              </Label>
            </div>
            <div
              className={`ps-photo ${
                this.state.image_url == null && this.state.image_url.length < 1
                  ? ' empty'
                  : ''
              }`}
            >
              {this.state.image_url == null &&
                this.state.image_url.length < 1 && <p>No image</p>}
              {this.state.image_url != null && this.state.image_url.length > 0 && (
                <div className="image">
                  <img src={this.state.image_url} alt="logo" />
                </div>
              )}
            </div>
          </FormGroup> */}
          <FormGroup>
            <Label>
              Store Logo (Recommended size with aspect ratio of 1:1, e.g. 512
              *512, Limit to 2MB)
            </Label>
            <div
              className={`ps-photo ${
                this.state.image_url.length < 1 ? ' empty' : ''
              }`}
              style={{
                border: 'none',
                display: 'flex',
                justifyContent: 'center',
                padding: 0,
              }}
            >
              {this.state.image_url.length < 1 && <p>No image</p>}
              {this.state.image_url.length > 0 && (
                <div className="image">
                  <img src={this.state.image_url} alt="logo" />
                </div>
              )}
            </div>
            <Input
              type="file"
              name="file"
              id="file"
              //className="ps-input-file"
              onChange={this.handleAttachmentChange}
            />
          </FormGroup>
          <FormGroup>
            <Label>Store Name</Label>
            <Input
              type="text"
              name="company_name"
              value={this.state.company_name}
              onChange={this.changeHandler}
            />
          </FormGroup>
          <FormGroup>
            <Label>Receipt Header</Label>
            <Input
              type="textarea"
              rows={4}
              name="invoice_info"
              value={this.state.invoice_info}
              onChange={this.changeHandler}
            />
          </FormGroup>
          <FormGroup>
            <Label>Quotation T&C</Label>
            <Input
              type="textarea"
              rows={4}
              name="quotation_tc"
              value={this.state.quotation_tc}
              onChange={this.changeHandler}
            />
          </FormGroup>
          <FormGroup>
            <Label>Receipt Footer Text</Label>
            <Input
              type="textarea"
              rows={4}
              name="footer_info"
              value={this.state.footer_info}
              onChange={this.changeHandler}
            />
          </FormGroup>
          <FormGroup>
            <Label>Receipt T&C</Label>
            <Input
              type="textarea"
              rows={4}
              name="invoice_tc"
              value={this.state.invoice_tc}
              onChange={this.changeHandler}
            />
          </FormGroup>
          <FormGroup>
            <Label>Web Header Text</Label>
            <Input
              type="textarea"
              rows={4}
              name="web_header"
              value={this.state.web_header}
              onChange={this.changeHandler}
            />
          </FormGroup>
          <FormGroup>
            <Label>Web Footer Text</Label>
            <Input
              type="textarea"
              rows={4}
              name="web_footer"
              value={this.state.web_footer}
              onChange={this.changeHandler}
            />
          </FormGroup>
          {/* <Row form>
            <Col md={6}>
              <FormGroup>
                <Label>Company Name</Label>
                <Input
                  type="text"
                  name="company_name"
                  value={this.state.company_name}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Receipt Header</Label>
                <Input
                  type="textarea"
                  rows={3}
                  name="invoice_info"
                  value={this.state.invoice_info}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Quotation T&C</Label>
                <Input
                  type="textarea"
                  rows={3}
                  name="quotation_tc"
                  value={this.state.quotation_tc}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              {' '}
              <FormGroup>
                <Label>Receipt Footer Text</Label>
                <Input
                  type="textarea"
                  rows={3}
                  name="footer_info"
                  value={this.state.footer_info}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Receipt T&C</Label>
                <Input
                  type="textarea"
                  rows={3}
                  name="invoice_tc"
                  value={this.state.invoice_tc}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Web Footer Text</Label>
                <Input
                  type="textarea"
                  rows={3}
                  name="web_footer"
                  value={this.state.web_footer}
                  onChange={this.changeHandler}
                />
              </FormGroup>
            </Col>
          </Row> */}
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default PosStoreConfigureModal;
